import { client } from '../../apiClient';
import { MonitorPromptGroup } from '../../../models/monitor/MonitorPromptGroup';

const ENDPOINT = '/prompt-groups';

export const getPromptGroups = async (projectId: number): Promise<MonitorPromptGroup[]> => {
  return client(true, true)
    .get<MonitorPromptGroup[]>(`${ENDPOINT}/${projectId}/groups`)
    .then((response) => response.data)
    .catch(() => []);
};

export const createPromptGroup = async (
  projectId: number,
  name: string,
  color?: string
): Promise<MonitorPromptGroup> => {
  return client(true, true)
    .post<MonitorPromptGroup>(`${ENDPOINT}/${projectId}/groups`, { name, color })
    .then((response) => response.data);
};

export const updatePromptGroup = async (
  projectId: number,
  groupId: number,
  data: { name?: string; color?: string }
): Promise<MonitorPromptGroup> => {
  return client(true, true)
    .put<MonitorPromptGroup>(`${ENDPOINT}/${projectId}/groups/${groupId}`, data)
    .then((response) => response.data);
};

export const deletePromptGroup = async (projectId: number, groupId: number): Promise<boolean> => {
  return client(true, true)
    .delete(`${ENDPOINT}/${projectId}/groups/${groupId}`)
    .then((response) => response.data);
};

export const reorderPromptGroups = async (
  projectId: number,
  orderedIds: number[]
): Promise<void> => {
  return client(true, true)
    .post(`${ENDPOINT}/${projectId}/groups/reorder`, { orderedIds })
    .then((response) => response.data);
};

export const assignPromptToGroup = async (
  projectId: number,
  promptId: number,
  groupId: number | null
): Promise<boolean> => {
  return client(true, true)
    .post(`${ENDPOINT}/${projectId}/groups/assign`, { promptId, groupId })
    .then((response) => response.data);
};

export const bulkAssignPromptsToGroup = async (
  projectId: number,
  promptIds: number[],
  groupId: number | null
): Promise<boolean> => {
  return client(true, true)
    .post(`${ENDPOINT}/${projectId}/groups/bulk-assign`, { promptIds, groupId })
    .then((response) => response.data);
};
